export default {
  allDestinations: (state) => state.destinations,
  destinationsLoading: (state) => state.destinationsLoading
}
